import type { AssetTypeDetailsTabWrapperProps } from "./asset-type-details-tab.type";

import AssetTypeDetailsTab from "./asset-type-details-tab.component";

const AssetTypeDetailsTabWrapper = ({
  assetType,
}: AssetTypeDetailsTabWrapperProps) => {
  if (!assetType) return null;

  return <AssetTypeDetailsTab assetType={assetType} />;
};

export default AssetTypeDetailsTabWrapper;
